/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createBitNot } from '../../factoriesAny.js';
export var bitNotDependencies = {
  typedDependencies,
  createBitNot
};